import React, { useState } from "react";
import { getCountries } from "../../../../MyApi/admin/countries/countries";
import { getCities } from "../../../../MyApi/admin/cities";
import { getZones } from "../../../../MyApi/zones";
import { getGovernorates } from "../../../../MyApi/admin/governorates";
import { useQuery } from "react-query";
import TrackingMapGoogle from "../../../map/trackingGooleMap";
import Select from "react-select";    

const AddressInfo = ({ addressInfo, setAddressInfo ,area ,setArea  ,formErrors}) => {

  // Queries
  const { data: citiesData  ,isLoading:isCitiesLoading} = useQuery(["getCities" ,addressInfo.governorate_id], ()=>getCities("" ,"", addressInfo.governorate_id));   
  const { data: countriesData ,isLoading:isCountriesLoading } = useQuery("getCountries" , ()=>getCountries());
  const { data: governorateData  ,isLoading:isGovernorateLoading} = useQuery(
    ["getGovernorates" ,addressInfo.country_id],
    ()=>getGovernorates(addressInfo.country_id)
  );
  const { data: zonesData  ,isLoading:isZonesLoading} = useQuery(["getZones" ,addressInfo.city_id], ()=>getZones("",addressInfo.city_id));

  const countries = countriesData?.data.countries ?? [];
  const governorates = governorateData?.data?.governorates ?? [];
  const cities = citiesData?.data?.cities ?? [];
  const zones = zonesData?.data?.zones ?? [];

  // Handle normal inputs
  const handleChange = (e) => {
    setAddressInfo({ ...addressInfo, [e.target.name]: e.target.value });
  };

  // Handle react-select
  const handleSelect = (field, option) => {
    setAddressInfo({ ...addressInfo, [field]: option?.id || null });
    if(field ==="zone_id"){
    setArea(option.area)
    }

  };

  return (
    <div className="row mt-4">
      <h6 className="font16">العنوان</h6>

      {/* العنوان التفصيلي */}
      <div className="col-12 mb-3">
        <label className="form-label">العنوان التفصيلي</label>
        <input
          type="text"
          name="address_line_1"
          className="form-control"
          placeholder="ادخل العنوان"
          value={addressInfo.address_line_1}
          onChange={handleChange}
        />
      </div>

      {/* الدولة */}
      <div className="col-3 mb-3">
        <label className="form-label">الدولة</label>
        <Select
          options={countries}
          value={countries.find((c) => c.id === addressInfo.country_id) || null}
          onChange={(opt) => handleSelect("country_id", opt)}
          getOptionLabel={(opt) => opt.name}
          getOptionValue={(opt) => opt.id}
          placeholder="اختر الدولة"
          isLoading={isCountriesLoading}
        />
      </div>

      {/* المحافظة */}
      <div className="col-3 mb-3">
        <label className="form-label">المحافظة</label>
        <Select
          options={governorates}
          value={
            governorates.find((g) => g.id === addressInfo.governorate_id) ||
            null
          }
          onChange={(opt) => handleSelect("governorate_id", opt)}
          getOptionLabel={(opt) => opt.name}
          getOptionValue={(opt) => opt.id}
          placeholder="اختر المحافظة"
          isLoading={isGovernorateLoading}
        />
      </div>

      {/* المدينة */}
      <div className="col-3 mb-3">
        <label className="form-label">المدينة</label>
        <Select
          options={cities}
          value={cities.find((c) => c.id === addressInfo.city_id) || null}
          onChange={(opt) => handleSelect("city_id", opt)}
          getOptionLabel={(opt) => opt.name}
          getOptionValue={(opt) => opt.id}
          placeholder="اختر المدينة"
          isLoading={isCitiesLoading}
        />
      </div>

      {/* المنطقة */}
      <div className="col-3 mb-3">
        <label className="form-label">المنطقة</label>
        <Select
          options={zones}
          value={zones.find((z) => z.id === addressInfo.zone_id) || null}
          onChange={(opt) => handleSelect("zone_id", opt)}
          getOptionLabel={(opt) => opt.name}
          getOptionValue={(opt) => opt.id}
          placeholder="اختر المنطقة"
          isLoading={isZonesLoading}
        />
        {formErrors.zone_id && <div className="d-block invalid-feedback">{formErrors.zone_id}</div>}
      </div>
       
      {/* خريطة */}
      <h6 className="font16 mt-3">اختر الموقع على الخريطة</h6>

      {formErrors.latitude && <div className="d-block invalid-feedback"> {formErrors.latitude} </div>}
      <TrackingMapGoogle  
      setArea={setArea}
        setLocations={(point) =>
          setAddressInfo({
            ...addressInfo,
            latitude: point.lat,
            longitude: point.long,
          })
        }
        locations={{lat:addressInfo.latitude ,long:addressInfo.longitude}}
        area={area}
      />
    </div>
  );
};

export default AddressInfo;
